import {AccordionDetails, AccordionSummary, Box, Stack, Typography} from '@mui/material';
import {MainFooter, StyledGrid} from 'presentation/components';
import React, {Fragment, useState} from 'react';

import {ProductEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {formatAddress, formatText} from 'presentation/utils';
import {useTheme} from 'styled-components';
import {ccgUnits, clinipamUnits, gndiminasUnits, gndiUnits, hapUnits} from './constants';
import {AccordionStyled} from './styles';

const {description, serviceHours, address} = translations['pt-br'].privateFlow.help.ourAddresses;

export function ServicePointsDeprecated() {
	const {isMobile} = useMediaQueries();
	const theme = useTheme();

	const {
		dataHostNameState: {product},
	} = useHostName();
	const [expandedList, setExpandedList] = useState<string[]>([]);

	const handleExpandToggle = (unitName: string) => {
		if (expandedList.includes(unitName)) {
			setExpandedList(prev => prev.filter(name => name !== unitName));
		} else {
			setExpandedList(prev => [...prev, unitName]);
		}
	};

	const unitsList = {
		[ProductEnum.HAP]: hapUnits,
		[ProductEnum.CCG]: ccgUnits,
		[ProductEnum.CLINIPAM]: clinipamUnits,
		[ProductEnum.GNDI_MINAS]: gndiminasUnits,
		[ProductEnum.GNDI]: gndiUnits,
		[ProductEnum.NOTREDAME_SAUDE]: gndiUnits,
	};

	return (
		<Fragment>
			<StyledGrid.Root p={isMobile ? 2 : 4} spacing={3}>
				<StyledGrid.Item sm={12} md={12} lg={8}>
					<Typography variant="subheader" mb={1}>
						{description}
					</Typography>

					<Box>
						{unitsList[product].map((unit, index) => (
							<AccordionStyled
								key={index}
								expanded={expandedList.includes(`${unit.name}${unit.unitName}`)}
								onChange={() => handleExpandToggle(`${unit.name}${unit.unitName}`)}>
								<AccordionSummary
									expandIcon={
										<Icon
											name="expand-more-filled"
											color={theme.palette.primary.main}
										/>
									}>
									<Typography variant="body1">{formatText(unit.name)}</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<Stack gap={2}>
										<Stack gap={1}>
											<Typography variant="subheader">{address}</Typography>
											<Stack direction="row" alignItems="flex-start" gap={1}>
												<Icon
													name="location-on-filled"
													color={theme.palette.primary.main}
													size={20}
												/>
												<Typography variant="body2">
													{formatAddress({
														address: unit.address,
														zipCode: unit.zipCode,
														city: unit.city,
														state: unit.uf,
													})}
												</Typography>
											</Stack>
										</Stack>

										<Stack gap={1}>
											<Typography variant="subheader">
												{serviceHours}
											</Typography>
											<Stack gap={0.5}>
												{unit.workHours.map((hours, index) => (
													<Typography key={index} variant="body2">
														{hours}
													</Typography>
												))}
											</Stack>
										</Stack>
									</Stack>
								</AccordionDetails>
							</AccordionStyled>
						))}
					</Box>
				</StyledGrid.Item>
			</StyledGrid.Root>

			<Box mt="auto" p={isMobile ? 0 : 4}>
				<StyledGrid.Root>
					<StyledGrid.Item sm={12} md={12} lg={8}>
						<MainFooter noMargin={!isMobile} />
					</StyledGrid.Item>
				</StyledGrid.Root>
			</Box>
		</Fragment>
	);
}
